<h1 mat-dialog-title class="dialog-header">{{ "Add SMA" | translate }}</h1>

<mat-dialog-content class="mat-typography">
  <form [formGroup]="form">
    <p class="info-text">{{ "Adding SMA option to licence" | translate }}</p>

    <mat-form-field class="full-width">
      <mat-label>{{ "Order Confirmation (AB)" | translate }}</mat-label>
      <input matInput type="text" formControlName="document_number" placeholder="AB 2023-000011" />
    </mat-form-field>

    <mat-form-field class="full-width">
      <mat-label>{{ "Product ID" | translate }}</mat-label>
      <input matInput type="text" formControlName="product_id" placeholder="SMA-01-E" />
    </mat-form-field>

    <mat-form-field class="full-width">
      <mat-label>{{ "Start Date" | translate }}</mat-label>
      <input matInput type="date" formControlName="start_date" required />
      <mat-error *ngIf="form.get('start_date')?.hasError('required')">
        {{ "Start date is required" | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field class="full-width">
      <mat-label>{{ "End Date" | translate }}</mat-label>
      <input matInput type="date" formControlName="end_date" />
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">{{ "Cancel" | translate }}</button>
  <button mat-flat-button color="primary" [disabled]="!form.valid" (click)="save()">
    {{ "Save" | translate }}
  </button>
</mat-dialog-actions>
